export default __webpack_public_path__ + "static/media/hero-b.df5b9aa7.png";